export * from './constant-analystic';

export const SET_RESUME_POPUP = 'SET_RESUME_POPUP';
export const MOTIVATE_CART_STATUS_CHANGE = 'MOTIVATE_CART_STATUS_CHANGE';
export const SAVE_MOTIVATE_CART_RESULT = 'SAVE_MOTIVATE_CART_RESULT';
export const REMOVE_SPEC_COLLECTION_SELECTED_HANDLE = 'REMOVE_SPEC_COLLECTION_SELECTED_HANDLE';
export const GET_SHOP_DATA = 'GET_SHOP_DATA';
export const RECEIVED_SHOP_DATA = 'RECEIVED_SHOP_DATA';
export const GET_STATISTICS = 'GET_STATISTICS';
export const GET_QUICK_VIEW_ADD_CART_STATISTICS = 'GET_QUICK_VIEW_ADD_CART_STATISTICS';
export const GET_PIE_CHAR_REPORT = 'GET_PIE_CHAR_REPORT';
export const RECEIVED_PIE_CHART_REPORT = 'RECEIVED_PIE_CHART_REPORT';
export const GET_STATISTICS_RESULT = 'GET_STATISTICS_RESULT';
export const CHANGE_APP_STATUS = 'CHANGE_APP_STATUS';
export const CHANGE_APP_STATUS_RESULT = 'CHANGE_APP_STATUS_RESULT';
export const CHANGE_APP_STATUS_CURRENCY = 'CHANGE_APP_STATUS_CURRENCY';
export const CHANGE_APP_STATUS_CURRENCY_RESULT = 'CHANGE_APP_STATUS_CURRENCY_RESULT';
export const CHANGE_APP_STATUS_TRANSLATE = 'CHANGE_APP_STATUS_TRANSLATE';
export const CHANGE_APP_STATUS_TRANSLATE_RESULT = 'CHANGE_APP_STATUS_TRANSLATE_RESULT';
export const SHOW_ON_MOBILE_CHANGE = 'SHOW_ON_MOBILE_CHANGE';
export const MOBILE_POSITION_CHANGE = 'MOBILE_POSITION_CHANGE';
export const KEEP_WHEN_HOVER_CHANGE = 'KEEP_WHEN_HOVER_CHANGE';
export const RESULT_SETTINGS = 'RESULT_SETTINGS';
export const SAVE_SETTINGS_RESULT = 'SAVE_SETTINGS_RESULT';
export const RESET_SAVE_SETTINGS_RESULT = 'RESET_SAVE_SETTINGS_RESULT';
export const SAVE_SETTINGS_HANDLE = 'SAVE_SETTINGS_HANDLE';
export const GET_RANDOM_PRODUCT = 'GET_RANDOM_PRODUCT';
export const RANDOM_PRODUCT_RESULT = 'RANDOM_PRODUCT_RESULT';
export const CHANGE_THEME = 'CHANGE_THEME';
export const TITLE_CHANGE_ORDER = 'TITLE_CHANGE_ORDER';
export const UPDATE_LOADED_GET_SETTINGS = 'UPDATE_LOADED_GET_SETTINGS';
export const PRODUCT_NAME_CHANGE_ORDER = 'PRODUCT_NAME_CHANGE_ORDER';
export const PRODUCT_NAME_CHANGE_CART = 'PRODUCT_NAME_CHANGE_CART';
export const NOTIFICATION_TIME_CHANGE_ORDER = 'NOTIFICATION_TIME_CHANGE_ORDER';
export const DESKTOP_POSITION_CHANGE = 'DESKTOP_POSITION_CHANGE';
export const DISPLAY_TIME_CHANGE = 'DISPLAY_TIME_CHANGE';
export const DELAY_BETWEEN_NOTIFICATION_CHANGE = 'DELAY_BETWEEN_NOTIFICATION_CHANGE';
export const MAXIMUM_ON_PAGE_CHANGE = 'MAXIMUM_ON_PAGE_CHANGE';
export const CUSTOMIZE_THEME_CHANGE = 'CUSTOMIZE_THEME_CHANGE';
export const NUMBER_ORDER_RESULT = 'NUMBER_ORDER_RESULT';
export const CHANGE_HOLIDAY_THEME = 'CHANGE_HOLIDAY_THEME';
export const CHANGE_LAYOUT = 'CHANGE_LAYOUT';
export const CHANGE_BACKGROUND_TEXT_TITLE = 'CHANGE_BACKGROUND_TEXT_TITLE';
export const SET_COLOR = 'SET_COLOR';
export const SET_COLOR_TIMER = 'SET_COLOR_TIMER';
export const UPDATE_SALES_POP_VERSION = 'UPDATE_SALES_POP_VERSION';
export const UPDATE_TYPE_CHANGE_POPUP = 'UPDATE_TYPE_CHANGE_POPUP';
export const UPDATE_SHOW_POPUP_ITSELF = 'UPDATE_SHOW_POPUP_ITSELF';
export const CHANGE_NUMBER_OF_ORDERS_SAGA = 'CHANGE_NUMBER_OF_ORDERS_SAGA';
export const CHANGE_NUMBER_OF_ORDER_IN_REDUCER = 'CHANGE_NUMBER_OF_ORDER_IN_REDUCER';
export const CART_TITLE_ON_CHANGE = 'CART_TITLE_ON_CHANGE';

export const CHANGE_CUSTOMIZE_THEME_BACKGROUND = 'CHANGE_CUSTOMIZE_THEME_BACKGROUND';
export const CHANGE_CUSTOMIZE_THEME_TITLE = 'CHANGE_CUSTOMIZE_THEME_TITLE';
export const CHANGE_CUSTOMIZE_THEME_PRODUCT_NAME = 'CHANGE_CUSTOMIZE_THEME_PRODUCT_NAME';
export const CHANGE_CUSTOMIZE_THEME_TIME = 'CHANGE_CUSTOMIZE_THEME_TIME';

// Check show popUp
export const SELECT_DELAY_SHOW_POPUP = 'SELECT_DELAY_SHOW_POPUP';
export const NUMBER_DELAY_SHOW_POPUP = 'NUMBER_DELAY_SHOW_POPUP';

// Reset save
export const RESET_CHANGE_STATUS_APP_RESULT = 'RESET_CHANGE_STATUS_APP_RESULT';
export const RESET_SAVE_STATUS_MOTIVATE_CART = 'RESET_SAVE_STATUS_MOTIVATE_CART';
export const RESET_SAVE_NUMBER_ORDER = 'RESET_SAVE_NUMBER_ORDER';
export const RESET_CHANGE_STATUS_APP_CURRENCY_RESULT = 'RESET_CHANGE_STATUS_APP_CURRENCY_RESULT';
export const RESET_CHANGE_STATUS_APP_TRANSLATE_RESULT = 'RESET_CHANGE_STATUS_APP_TRANSLATE_RESULT';

// order
export const UPDATE_IS_SAVE_SETTINGS_LOAD = 'UPDATE_IS_SAVE_SETTINGS_LOAD';
export const UPDATE_IS_SAVE_COUNTDOWN_SETTINGS_LOAD = 'UPDATE_IS_SAVE_COUNTDOWN_SETTINGS_LOAD';
export const UPDATE_IS_CART_BOOST_SALES_LOADING = 'UPDATE_IS_CART_BOOST_SALES_LOADING';
export const ORDER_LIST_ARRAY_MOVE = 'ORDER_LIST_ARRAY_MOVE';
export const GET_LIST_ORDER_ARRAY = 'GET_LIST_ORDER_ARRAY';
export const GET_LIST_ORDER_ARRAY_RESULT = 'GET_LIST_ORDER_ARRAY_RESULT';

// Change font +  font size
export const CHANGE_FONT_SIZE_TITLE = 'CHANGE_FONT_SIZE_TITLE';
export const CHANGE_FONT_SIZE_PRODUCT_NAME = 'CHANGE_FONT_SIZE_PRODUCT_NAME';
export const CHANGE_FONT_SIZE_TIME = 'CHANGE_FONT_SIZE_TIME';
export const CHANGE_FONT_FAMILY = 'CHANGE_FONT_FAMILY';
export const RESET_FONT_DEFAULT = 'RESET_FONT_DEFAULT';

// get info order first
export const GET_ORDER_FIRST = 'GET_ORDER_FIRST';
export const GET_ORDER_FIRST_RESULT = 'GET_ORDER_FIRST_RESULT';
export const GET_STATISTICS_CHART = 'GET_STATISTICS_CHART';
export const RECEIVED_STATISTICS_CHART = 'RECEIVED_STATISTICS_CHART';

// Reset text to default
export const ORDER_RESET_TITLE_TO_DEFAULT = 'ORDER_RESET_TITLE_TO_DEFAULT';
export const ORDER_RESET_PRODUCT_NAME_TO_DEFAULT = 'ORDER_RESET_PRODUCT_NAME_TO_DEFAULT';
export const ADDED_CART_TYPE_RESET_TITLE = 'ADDED_CART_TYPE_RESET_TITLE';
export const ADDED_CART_TYPE_RESET_PRODUCT_NAME = 'ADDED_CART_TYPE_RESET_PRODUCT_NAME';
export const UPDATE_RANDOM_DISPLAY = 'UPDATE_RANDOM_DISPLAY';

export const REMOVE_VERIFY_CHANGE = 'REMOVE_VERIFY_CHANGE';
export const UPDATE_EXTRA_SETTINGS_FIELD = 'UPDATE_EXTRA_SETTINGS_FIELD';
export const UPDATE_EXTRA_QUICK_VIEW_SETTINGS_FIELD = 'UPDATE_EXTRA_QUICK_VIEW_SETTINGS_FIELD';
export const UPDATE_EXTRA_COUNTDOWN_SETTINGS_FIELD = 'UPDATE_EXTRA_COUNTDOWN_SETTINGS_FIELD';
export const UPDATE_EXTRA_TARGETING_SETTINGS_FIELD = 'UPDATE_EXTRA_TARGETING_SETTINGS_FIELD';
export const UPDATE_EXTRA_COUNTDOWN_TIMER_SETTINGS_FIELD = 'UPDATE_EXTRA_COUNTDOWN_TIMER_SETTINGS_FIELD';
export const UPDATE_EXTRA_COUNTDOWN_STOCK_SETTINGS_FIELD = 'UPDATE_EXTRA_COUNTDOWN_STOCK_SETTINGS_FIELD';
export const UPDATE_COOKIE_BANNER_FIELD = 'UPDATE_COOKIE_BANNER_FIELD';
export const UPDATE_MOTIVATE_CART_FIELD = 'UPDATE_MOTIVATE_CART_FIELD';
export const UPDATE_DATE_RANGE_FIELD = 'UPDATE_DATE_RANGE_FIELD';
export const UPDATE_REPORT_BY_LABEL = 'UPDATE_REPORT_BY_LABEL';
export const UPDATE_QUICK_VIEW_ADD_CART_REPORT_BY_LABEL = 'UPDATE_QUICK_VIEW_ADD_CART_REPORT_BY_LABEL';

export const UPDATE_LANGUAGE = 'UPDATE_LANGUAGE';
export const GET_LANGUAGE_PACKAGE = 'GET_LANGUAGE_PACKAGE';
export const RECEIVED_CUSTOM_LANGUAGE = 'RECEIVED_CUSTOM_LANGUAGE';
export const RECEIVED_LANGUAGE_PACKAGE = 'RECEIVED_LANGUAGE_PACKAGE';
export const UPDATE_LANGUAGE_FIELD = 'UPDATE_LANGUAGE_FIELD';
export const UPDATE_LANGUAGE_PACKAGE = 'UPDATE_LANGUAGE_PACKAGE';
export const SAVE_LANGUAGE = 'SAVE_LANGUAGE';
export const SAVE_LANGUAGE_RESULT = 'SAVE_LANGUAGE_RESULT';

export const CREATE_FEATURE_REQUEST = 'CREATE_FEATURE_REQUEST';
export const RESET_REQUEST_RESULT_FAQ = 'RESET_REQUEST_RESULT_FAQ';
export const SUBMIT_ISSUE_HANDLING = 'SUBMIT_ISSUE_HANDLING';
export const UPDATE_IS_LOADING_SUBMIT_FEATURE_REQUEST = 'UPDATE_IS_LOADING_SUBMIT_FEATURE_REQUEST';
export const UPDATE_IS_LOADING_SUBMIT_ISSUE = 'UPDATE_IS_LOADING_SUBMIT_ISSUE';
export const UPDATE_SUBMIT_FEATURE_REQUEST_RESULT = 'UPDATE_SUBMIT_FEATURE_REQUEST_RESULT';
export const UPDATE_SUBMIT_ISSUE_RESULT = 'UPDATE_SUBMIT_ISSUE_RESULT';
export const UPDATE_IS_LOADING_LIST_ITEM = 'UPDATE_IS_LOADING_LIST_ITEM';
export const CHANGE_WEEKLY_REPORT_HANDLE = 'CHANGE_WEEKLY_REPORT_HANDLE';
export const UPDATE_STATUS_WEEKLY_REPORT = 'UPDATE_STATUS_WEEKLY_REPORT';

export const UPDATE_LIST_ORDER_ITEM = 'UPDATE_LIST_ORDER_ITEM';
export const SET_HOVER_COLOR = 'SET_HOVER_COLOR';

export const UPDATE_IS_LOADING_SETTINGS = 'UPDATE_IS_LOADING_SETTINGS';

export const CHANGE_WELCOME = 'CHANGE_WELCOME';
export const MOTIVATE_BANNER_UPDATE = 'MOTIVATE_BANNER_UPDATE';

export const UPDATE_IS_SMART_HIDE_TIME_AGO = 'UPDATE_IS_SMART_HIDE_TIME_AGO';
export const UPDATE_TIME_AGO_VALUE = 'UPDATE_TIME_AGO_VALUE';
export const UPDATE_TIME_AGO_TYPE = 'UPDATE_TIME_AGO_TYPE';
export const RELOAD_TARGETING_PRODUCT_SELECTION_DISPLAY = 'RELOAD_TARGETING_PRODUCT_SELECTION_DISPLAY';
export const RELOAD_TARGETING_COLLECTION_SELECTION_DISPLAY = 'RELOAD_TARGETING_COLLECTION_SELECTION_DISPLAY';
export const REMOVE_PRODUCT_ID_TARGETING = 'REMOVE_PRODUCT_ID_TARGETING';
export const REMOVE_COLLECTION_ID_TARGETING = 'REMOVE_COLLECTION_ID_TARGETING';
export const UPDATE_COUNT_GET_SETTINGS = 'UPDATE_COUNT_GET_SETTINGS';

export const UPDATE_IS_LOADING_SUBMIT_CONTACT_COUNTDOWN = 'UPDATE_IS_LOADING_SUBMIT_CONTACT_COUNTDOWN';
export const UPDATE_SUBMIT_CONTACT_COUNTDOWN_RESULT = 'UPDATE_SUBMIT_CONTACT_COUNTDOWN_RESULT';
export const UPDATE_IS_LOADING_PRODUCT_IDS_SELECTED_DISPLAY = 'UPDATE_IS_LOADING_PRODUCT_IDS_SELECTED_DISPLAY';
export const RECEIVED_PRODUCT_IDS_SELECTED_DISPLAY = 'RECEIVED_PRODUCT_IDS_SELECTED_DISPLAY';
export const RECEIVED_COLLECTION_IDS_SELECTED_DISPLAY = 'RECEIVED_COLLECTION_IDS_SELECTED_DISPLAY';
export const UPDATE_IS_LOADING_COLLECTION_IDS_SELECTED_DISPLAY = 'UPDATE_IS_LOADING_COLLECTION_IDS_SELECTED_DISPLAY';
export const SUBMIT_CONTACT_COUNTDOWN_HANDLING = 'SUBMIT_CONTACT_COUNTDOWN_HANDLING';
export const UPDATE_IS_SAVING_LANGUAGE = 'UPDATE_IS_SAVING_LANGUAGE';
export const UPDATE_IS_SAVE_CUSTOM_LANGUAGE_SUCCESS = 'UPDATE_IS_SAVE_CUSTOM_LANGUAGE_SUCCESS';

export const UPDATE_PRODUCT_SELECTED_DISPLAY = 'UPDATE_PRODUCT_SELECTED_DISPLAY';
export const REMOVE_SPEC_PRODUCT_SELECTED = 'REMOVE_SPEC_PRODUCT_SELECTED';
export const REMOVE_SPEC_COLLECTION_SELECTED = 'REMOVE_SPEC_COLLECTION_SELECTED';
export const RELOAD_PRODUCT_SELECTED_DISPLAY = 'RELOAD_PRODUCT_SELECTED_DISPLAY';
export const UPDATE_CART_BOOST_SALES_BY_FIELD = 'UPDATE_SOCIAL_LIST_FIELD';
export const UPDATE_CART_BOOST_SALES_COLOR_PACK = 'UPDATE_CART_BOOST_SALES_COLOR_PACK';
export const REMOVE_SPEC_PRODUCT_SELECTED_HANDLE = 'REMOVE_SPEC_PRODUCT_SELECTED_HANDLE';
export const UPDATE_IS_LOADING_PRODUCT_SELECTED_DISPLAY = 'UPDATE_IS_LOADING_PRODUCT_SELECTED_DISPLAY';

export const SAVE_SETTING_DEFAULT_DESIGN = 'SAVE_SETTING_DEFAULT_DESIGN';
export const SAVE_DEFAULT_DESIGN_RESULT = 'SAVE_DEFAULT_DESIGN_RESULT';
export const RESET_SAVE_STATUS_DEFAULT_DESIGN = 'RESET_SAVE_STATUS_DEFAULT_DESIGN';
export const ENABLE_CAMPAIGN_STATUS = 'ENABLE_CAMPAIGN_STATUS';
export const ENABLE_CAMPAIGN_RESULT = 'ENABLE_CAMPAIGN_RESULT';
export const RESET_ENABLE_CAMPAIGN_RESULT = 'RESET_ENABLE_CAMPAIGN_RESULT';
export const GET_LIST_CAMPAIGN = 'GET_LIST_CAMPAIGN';
export const GET_LIST_CAMPAIGN_RESULT = 'GET_LIST_CAMPAIGN_RESULT';
export const GET_MISSING_ITEMS = 'GET_MISSING_ITEMS';
export const GET_MISSING_ITEMS_RESULT = 'GET_MISSING_ITEMS_RESULT';
export const SAVE_CAMPAIGN = 'SAVE_CAMPAIGN';
export const SAVE_CAMPAIGN_RESULT = 'SAVE_CAMPAIGN_RESULT';
export const RESET_SAVE_STATUS_CAMPAIGN = 'RESET_SAVE_STATUS_CAMPAIGN';
export const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN';
export const DELETE_CAMPAIGN_RESULT = 'DELETE_CAMPAIGN_RESULT';
export const RESET_DELETE_STATUS_CAMPAIGN = 'RESET_DELETE_STATUS_CAMPAIGN';
export const COUNTDOWN_CART_CHANGE_UPDATE_AT = 'COUNTDOWN_CART_CHANGE_UPDATE_AT';

export const SALES_POP_COUNTDOWN_TIMER_INTERVER = 'SALES_POP_COUNTDOWN_TIMER_INTERVER';
export const DASHBOARD_COUNT_CLICK_POPUP_UPGRADE = 'DASHBOARD_COUNT_CLICK_POPUP_UPGRADE';
export const CHANGE_STATUS_POPUP_UPGRADE = 'CHANGE_STATUS_POPUP_UPGRADE';

// CHỨC NĂNG HIỂN THỊ SẢN PHẨM NỔI BẬT, GHIM TRÊN ĐẦU LIST CÁC ORDER.

export const CHANGE_FEATURED_PRODUCT_COMMON = 'CHANGE_FEATURED_PRODUCT_COMMON';
export const CHANGE_FEATURED_PRODUCT_DESIGN_COMMON = 'CHANGE_FEATURED_PRODUCT_DESIGN_COMMON';
export const GET_LIST_PRODUCTS_DETAIL = 'GET_LIST_PRODUCTS_DETAIL';

// THU PHÍ MUA THÊM CHO CHỨC NĂNG MÓI

export const UPGRADE_TO_BUY_MORE = 'UPGRADE_TO_BUY_MORE';

//
export const COUNT_REPORT_BOST_SALE_QUICK_VIEW = 'COUNT_REPORT_BOST_SALE_QUICK_VIEW';
export const UPGRADE_PALN_PACKAGE = 'UPGRADE_PALN_PACKAGE';
export const DOWNGRADE_PALN_PACKAGE = 'DOWNGRADE_PALN_PACKAGE';

export const CHANGE_THEME_EVEN_POPUP = 'CHANGE_THEME_EVEN_POPUP';
export const GET_LIST_NOTIFICATION = 'GET_LIST_NOTIFICATION';
export const GET_LIST_NOTIFICATION_RESULT = 'GET_LIST_NOTIFICATION_RESULT';
export const GET_NOTIFICATION_DETAIL = 'GET_NOTIFICATION_DETAIL';
export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION';
export const UPDATE_NOTIFICATION_RESULT = 'UPDATE_NOTIFICATION_RESULT';
export const GET_NOTIFICATION_DETAIL_RESULT = 'GET_NOTIFICATION_DETAIL_RESULT';

export const CHOOSE_CURRENCIES = 'CHOOSE_CURRENCIES';
export const CHANGE_CURRENCY_SEARCH = 'CHANGE_CURRENCY_SEARCH';
export const DELETE_ALL_CURRENCIES = 'DELETE_ALL_CURRENCIES';
export const CHECKBOX_ALL_CURRENCIES = 'CHECKBOX_ALL_CURRENCIES';
export const CHECKBOX_DESKTOP_MOBILE = 'CHECKBOX_DESKTOP_MOBILE';
export const CHANGE_ADD_CUSTOMER_CURRENCY = 'CHANGE_ADD_CUSTOMER_CURRENCY';
export const SET_SHOP_SETTINGS = 'SET_SHOP_SETTINGS';
export const GET_SHOP_SETTINGS = 'GET_SHOP_SETTINGS';
export const ADD_CURRENCIES = 'ADD_CURRENCIES';
export const ARRAY_MOVE_CURRENCIES = 'ARRAY_MOVE_CURRENCIES';
export const DELETE_CURRENCIES = 'DELETE_CURRENCIES';

export const GET_CURRENCY_RATE = 'GET_CURRENCY_RATE';
export const GET_CURRENCY_RATE_RESPONSE = 'GET_CURRENCY_RATE_RESPONSE';

export const TURN_ON_OFF = 'TURN_ON_OFF';
export const CURRENCIES_TEMPORARY = 'CURRENCIES_TEMPORARY';

export const CHANGE_THEME_CURRENCY = 'CHANGE_THEME_CURRENCY';

export const CHANGE_COLOR = 'CHANGE_COLOR';

export const CHANGE_SIZE_FLAGS = 'CHANGE_SIZE_FLAGS';

export const CHANGE_CURRENCY_BESIDE = 'CHANGE_CURRENCY_BESIDE';

export const CHANGE_POSITION = 'CHANGE_POSITION';

export const CHANGE_POSITION_FLOAT = 'CHANGE_POSITION_FLOAT';

export const ADD_ROUNDING_RULE = 'ADD_ROUNDING_RULE';

export const EDIT_ROUNDING_RULE = 'EDIT_ROUNDING_RULE';

export const DELETE_ROUNDING_RULE = 'DELETE_ROUNDING_RULE';

export const CHANGE_MESSAGE = 'CHANGE_MESSAGE';

export const SEND_CONTACT_POSITION = 'SEND_CONTACT_POSITION';

export const SEND_CONTACT_CHECKOUT = 'SEND_CONTACT_CHECKOUT';

export const CHANGE_CONTACT_POSITION = 'CHANGE_CONTACT_POSITION';

export const CHANGE_CONTACT_CHECKOUT = 'CHANGE_CONTACT_CHECKOUT';

export const SAVE_SETTINGS_CURRENCY = 'SAVE_SETTINGS_CURRENCY';

export const SAVE_SETTINGS_RESPONSE = 'SAVE_SETTINGS_RESPONSE';

export const UPDATE_IS_SAVED = 'UPDATE_IS_SAVED';

export const UPGRADE_PACKAGE_PRO = 'UPGRADE_PACKAGE_PRO';

export const UPGRADE_PACKAGE_PRO_RESPONSE = 'UPGRADE_PACKAGE_PRO_RESPONSE';

export const DOWNGRADE_PACKAGE_PRO = 'DOWNGRADE_PACKAGE_PRO';

export const CHANGE_DISPLAY_DEVICE = 'CHANGE_DISPLAY_DEVICE';

export const PRICE_CONFIGURATION = 'PRICE_CONFIGURATION';

export const GET_SHOP_INFO = 'GET_SHOP_INFO';

export const SET_SHOP_INFO = 'SET_SHOP_INFO';

export const CHANGE_SAVER_BAR_SETTINGS = 'CHANGE_SAVER_BAR_SETTINGS';

// TRANSLATE

export const CHANGE_POSITION_TRANSLATE = 'CHANGE_POSITION_TRANSLATE';

export const CHANGE_POSITION_FLOAT_TRANSLATE = 'CHANGE_POSITION_FLOAT_TRANSLATE';

export const CHANGE_TRANSLATE_BESIDE = 'CHANGE_TRANSLATE_BESIDE';

export const DELETE_ALL_TRANSLATE = 'DELETE_ALL_TRANSLATE';

export const CHECKBOX_ALL_TRANSLATE = 'CHECKBOX_ALL_TRANSLATE';

export const CHOOSE_TRANSLATE = 'CHOOSE_TRANSLATE';

export const TRANSLATE_TEMPORARY = 'TRANSLATE_TEMPORARY';

export const CHANGE_TRANSLATE_SEARCH = 'CHANGE_TRANSLATE_SEARCH';

export const ADD_TRANSLATE = 'ADD_TRANSLATE';

export const CHANGE_THEME_TRANSLATE = 'CHANGE_THEME_TRANSLATE';

export const CHANGE_FONT_TRANSLATE = 'CHANGE_FONT_TRANSLATE';

export const CHANGE_COLOR_TRANSLATE = 'CHANGE_COLOR_TRANSLATE';

export const CHANGE_MARGIN = 'CHANGE_MARGIN';

export const DELETE_TRANSLATE = 'DELETE_TRANSLATE';

export const ARRAY_MOVE_TRANSLATE = 'ARRAY_MOVE_TRANSLATE';

export const GET_SHOP_SETTINGS_TRANSLATE = 'GET_SHOP_SETTINGS_TRANSLATE';

export const SAVE_SETTINGS_TRANSLATE = 'SAVE_SETTINGS_TRANSLATE';

export const SAVE_SETTINGS_RESPONSE_TRANSLATE = 'SAVE_SETTINGS_RESPONSE_TRANSLATE';

export const CHANGE_POP_DROPDOWN = 'CHANGE_POP_DROPDOWN';

export const CHANGE_BORDER_WIDTH = 'CHANGE_BORDER_WIDTH';

export const CHANGE_FONT_SIZE = 'CHANGE_FONT_SIZE';

export const SET_SHOP_SETTINGS_TRANSLATE = 'SET_SHOP_SETTINGS_TRANSLATE';

export const CHANGE_PREVIEW = 'CHANGE_PREVIEW';

export const CHANGE_CURRENCY_SETTING_FIELD = 'CHANGE_CURRENCY_SETTING_FIELD';

export const CHANGE_TRANSLATE_SETTING_FIELD = 'CHANGE_TRANSLATE_SETTING_FIELD';

export const GET_COUNT_TOTAL = 'GET_COUNT_TOTAL';

export const GET_DATE_TIME = 'GET_DATE_TIME';

export const SET_COUNT_TOTAL = 'SET_COUNT_TOTAL';

export const SET_DATE_TIME = 'SET_DATE_TIME';

export const CHANGE_DISPLAY_DEVICE_TRANSLATE = 'CHANGE_DISPLAY_DEVICE_TRANSLATE';

export const CHANGE_DISPLAY_SETTINGS = 'CHANGE_DISPLAY_SETTINGS';

export const CHANGE_SHOPIFY = 'CHANGE_SHOPIFY';
